import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from 'stores/authStore';
import Layout from './Layout';

const ProtectedRoute: React.FC = () => {
  const { token } = useAuthStore();

  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default ProtectedRoute;